import React from "react";

/**
 * props:
 *    Array users
 *    Function deactivateUser
 *    Boolean canEdit
 **/
const UsersTable = (props) => {
  const change_faculty_role_display = props.users.map((user) => {
    if (user.role_lookup) {
      if (user.role_lookup.name == "FACULTY") {
        user.role_lookup.name = "FACULTY/STAFF";
      }
    }
  });
  const alphabetical = [];
  const users_list = props.users.map((user, i) => {
    alphabetical.push(user);
    let actionsDiv = (
      <td className="d-flex test-actions-col">
        <a href={process.env.BASE_URL + "changepw/" + user.id}>
          <button
            className="btn btn-info xs-font test-userpw-btn"
            style={{ lineHeight: "100%" }}
          >
            change password
          </button>
        </a>
      </td>
    );
    return (
      <tr
        key={"user-td-" + i}
        id={`test-user-${user.id}`}
        className="justify-content-left buffer-top test-user-row"
      >
        <td className="inner-buffer test-name-col">
          <a href={"../user/" + user.id}>{user.full_name}</a>
        </td>
        <td className="inner-buffer test-email-col">{user.email}</td>
        <td className="inner-buffer test-univ-col">
          {user.univ_lookup ? user.univ_lookup.name : ""}
        </td>
        {change_faculty_role_display}
        {props.canEdit == true ? (
          <td className="inner-buffer test-role-col">
            {user.role_lookup ? user.role_lookup.name : ""}
          </td>
        ) : (
          ""
        )}
        {user.can_update ? actionsDiv : <td></td>}
      </tr>
    );
  });

  const user_table = props.canEdit ? (
    <tr>
      <th>Full Name</th>
      <th>Email</th>
      <th>Institution</th>
      <th>Role</th>
      <th>Actions</th>
    </tr>
  ) : (
    <tr>
      <th>Full Name</th>
      <th>Email</th>
      <th>Institution</th>
      <th>Actions</th>
    </tr>
  );

  return (
    <div>
      <table className="table table-bordered">
        {console.log("CAN EDIT? ", props.canEdit)}
        {console.log("Alphabetical array ", alphabetical)}
        <thead>{user_table}</thead>
        <tbody>{users_list}</tbody>
      </table>
    </div>
  );
};

export default UsersTable;
